import { gql } from "@apollo/client";

const UPDATE_TRIAL_PACKAGE = gql`
  mutation UpdateTrialPackage($input: UpdateTrialPackageInput!) {
    updateTrialPackage(input: $input) {
      trialPackage {
        id
        status
      }
    }
  }
`;

export default UPDATE_TRIAL_PACKAGE;
